import { render, staticRenderFns } from "./navigation-report.vue?vue&type=template&id=fc4c6580&scoped=true&"
import script from "./navigation-report.vue?vue&type=script&lang=js&"
export * from "./navigation-report.vue?vue&type=script&lang=js&"
import style0 from "./navigation-report.vue?vue&type=style&index=0&id=fc4c6580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4c6580",
  null
  
)

export default component.exports